import { useState } from "react";
import { Link } from "react-router-dom";
import { List, ArrowRight } from "@phosphor-icons/react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { SidebarContent } from "@/components/layout/Sidebar";
import { buildPath } from "@/lib/routes";
import { useLang } from "@/hooks/useLang";

export default function FloatingCta({ profile }) {
  const { lang, t } = useLang();
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Mobile hamburger — floating top-left */}
      <div className="fixed left-4 top-4 z-40 lg:hidden">
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button data-testid="mobile-menu-trigger" aria-label="Menu"
              className="glass flex h-11 w-11 items-center justify-center rounded-full border border-border shadow-lg">
              <List size={20} />
            </button>
          </SheetTrigger>
          <SheetContent side="left" className="w-[300px] border-border bg-background p-0">
            <SidebarContent profile={profile} onNavigate={() => setOpen(false)} />
          </SheetContent>
        </Sheet>
      </div>

      {/* Floating "Let's talk" CTA — top-right */}
      <Link
        to={buildPath("contact", lang)}
        data-testid="floating-cta"
        className="group fixed right-4 top-4 z-40 inline-flex items-center gap-2 rounded-full border border-border bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground shadow-lg transition-transform hover:scale-[1.04] md:right-6"
      >
        {t("cta_talk")}
        <ArrowRight size={16} weight="bold" className="transition-transform group-hover:translate-x-0.5" />
      </Link>
    </>
  );
}
